import { initRealtyGallery } from '../realty/gallery-slider';

$(function(){
	var buttonMoreEls = $('.top-realties__more .btn');

	// on click load more items
	buttonMoreEls.on('click', function(){
		var thisEl = $(this);
		var itemsEl = thisEl.closest('.top-realties').find('.top-realties__items');

		// get params
		var page 		 = thisEl.attr('data-page');
		var per_page = thisEl.attr('data-per-page');

		// get items from ajax
		$.ajax({
			url: ajaxurl,
			type: 'post',
			data: {
				action: 'top_realties_more',
				page: page,
				per_page: per_page
			},
			dataType: 'json',
			success: function(result){
				// if there is no items hide button
				if(!result.html) {
					thisEl.closest('.top-realties__more').fadeOut();
					return;
				}

				// if success add items
				itemsEl.append(result.html);

				// add one page to button
				thisEl.attr('data-page', +thisEl.attr('data-page') + 1);

				// reinitialize gallery slider
				initRealtyGallery();

				// if those were last items hide button
				if(result.count <= thisEl.closest('.top-realties').find('.realty-item').length) {
					thisEl.closest('.top-realties__more').fadeOut();
					return;
				}

				// if last page hide button
				if(+thisEl.attr('data-max-pages') <= +thisEl.attr('data-page')) {
					thisEl.closest('.top-realties__more').fadeOut();
				}
			},
			error: function(error){
				console.log(error);
				alert('Произошла непредвиденная ошибка');
			}
		});
	});
});